<template>
  <div
    class="block-play-imageupload"
    :class="{ 'is-on-grid': isOnGrid }"
  >
    <div class="block-play-imageupload__inner">
      <AtomTextHeading
        v-if="title"
        :text="title"
        font-size="h3"
      />

      <div class="block-play-imageupload__grid">
        <AtomTextRichtext
          v-if="text"
          :html="text"
          font-size="small"
          class="block-play-imageupload__text"
        />

        <AtomInputImages
          :is-loading="isLoading"
          v-bind="uploadData"
          class="block-play-imageupload__input"
          @on-submit="handleSubmit"
        />
      </div>
    </div>

    <transition name="fade-in">
      <AtomPopoverNotification
        v-if="popupVisible"
        position="absolute"
        :text="errorMessage"
        :use-click-outside="true"
        type="error"
        @on-hide="popupVisible = false"
      />
    </transition>
  </div>
</template>

<script setup>
const props = defineProps({
    isOnGrid: {
        type: Boolean,
        default: false,
    },

    title: {
        type: String,
        default: '',
    },

    text: {
        type: String,
        default: '',
    },

    uploadData: {
        type: Object,
        default: () => {},
    },

    /*
        Error handling
    */
    errorMessage: {
        type: String,
        default: '',
    },

    /*
        Redirect
    */
    winsButtonLink: {
        type: String,
        default: '',
    },

    winsButtonText: {
        type: String,
        default: '',
    },
});

const isLoading = ref(false);
const popupVisible = ref(false);

const handleSubmit = async (fileArray) => {
    if (!fileArray) return;
    isLoading.value = true;

    try {
        const result = await usePlayPhotoUpload({
            files: fileArray,
        });

        const mappedPrizes = result.map((entry) => ({
            prize: entry.prize,
            code: entry.code,
        }));

        setCurrentWins(mappedPrizes, {
            link: props.winsButtonLink,
            text: props.winsButtonText,
        });

        const localePath = useLocalePath();
        await navigateTo(localePath('/current-wins'));
    } catch (e) {
        useSentryError(e, false);
        popupVisible.value = true;
    } finally {
        isLoading.value = false;
    }
};
</script>

<style lang="scss" scoped>
.block-play-imageupload {
    &.is-on-grid {
        @include wrapper-layout;
        @include grid-layout;

        margin-bottom: var(--m-bottom--big);
    }
}

.block-play-imageupload__inner {
    @include box-default;

    .is-on-grid & {
        @include default-content-columns('wide');
    }
}

.block-play-imageupload__grid {
    @include grid-layout(1, 1, 12);

    margin-top: 20px;
}

.block-play-imageupload__text {
    @include tablet {
        grid-column-end: span 5;
    }
}

.block-play-imageupload__input {
    @include tablet {
        grid-column-end: span 7;
    }
}
</style>
